<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ item_id ? "Update Item" : "Create New Item" }}
        </h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="submitHandler">
          <!-- Row 1 -->
          <div class="row">
            <div class="form-group col-md-6">
              <label>Item Name</label>
              <input
                v-model="form.item_name"
                type="text"
                class="form-control"
                placeholder="Enter item name"
              />
            </div>

            <div class="form-group col-md-6">
              <label>Brand Name</label>
              <input
                v-model="form.brand_name"
                type="text"
                class="form-control"
                placeholder="Enter brand name"
              />
            </div>
          </div>

          <!-- Row 2 -->
          <div class="row">
            <div class="form-group col-md-6">
              <label>Item Category</label>
              <select v-model="form.item_category_id" class="form-control">
                <option value="">Choose...</option>
                <option
                  v-for="category in all_cats.filter((c) => c && c.id)"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.category_name }}
                </option>
              </select>
            </div>

            <div class="form-group col-md-6">
              <label>Item Class</label>
              <select v-model="form.item_class_id" class="form-control">
                <option value="">Choose...</option>
                <option
                  v-for="clas in all_clas.filter((c) => c && c.id)"
                  :key="clas.id"
                  :value="clas.id"
                >
                  {{ clas.class_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="row">
            <div class="form-group col-md-4">
              <label>Item Strength</label>
              <input
                v-model="form.item_strength"
                type="text"
                class="form-control"
                placeholder="e.g., 500mg"
              />
            </div>

            <div class="form-group col-md-4">
              <label>Min Quantity</label>
              <input
                v-model="form.min_quantity"
                type="number"
                class="form-control"
              />
            </div>

            <div class="form-group col-md-4">
              <label>Reorder Level</label>
              <input
                v-model="form.reorder_level"
                type="number"
                class="form-control"
              />
            </div>
          </div>

          <!-- Row 4 -->
          <div class="form-group">
            <label>Item Composition</label>
            <input
              v-model="form.item_composition"
              type="text"
              class="form-control"
              placeholder="Composition of item"
            />
          </div>

          <div class="form-group">
            <label>Description</label>
            <input
              v-model="form.description"
              type="text"
              class="form-control"
              placeholder="Description of item"
            />
          </div>

          <!-- Submit -->
          <div class="text-end">
            <button type="submit" class="btn btn-primary">
              {{ item_id ? "Update Item" : "Create Item" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "CreateItemModal",
  props: {
    item_id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      all_cats: [],
      all_clas: [],
      form: {
        item_id: "",
        reorder_level: 0,
        min_quantity: 0,
        item_name: "",
        item_class_id: "",
        item_category_id: "",
        item_composition: "",
        description: "",
        brand_name: "",
        item_strength: "",
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-create-item-modal");
    },

    async submitHandler() {
      try {
        const url = "inventory/createCompanyItem";
        await generalApiRequest(url, "POST", this.form, 1);
        alert("Item saved successfully!");
        this.closeModal();
      } catch (error) {
        console.error("Error saving item:", error);
      }
    },

    async get_all_cats() {
      try {
        const res = await generalApiRequest(
          "inventory/getCompanyItemCategory",
          "GET",
          { plain: 1 },
          1
        );
        this.all_cats = Array.isArray(res)
          ? res.filter((c) => c && c.id)
          : res.data || [];
      } catch (error) {
        console.error("Error loading categories:", error);
        this.all_cats = [];
      }
    },

    async get_all_class() {
      try {
        const res = await generalApiRequest(
          "inventory/getCompanyItemClass",
          "GET",
          {},
          1
        );
        this.all_clas = Array.isArray(res)
          ? res.filter((c) => c && c.id)
          : res.data || [];
      } catch (error) {
        console.error("Error loading classes:", error);
        this.all_clas = [];
      }
    },

    async get_item_for_update() {
      if (!this.item_id) return;

      try {
        const res = await generalApiRequest(
          "getItemsById/" + this.item_id,
          "GET",
          {},
          1
        );
        const data = Array.isArray(res.data) ? res.data[0] : res.data;

        if (data) {
          console.log("this is the data");

          console.log(data);

          const form = {
            item_id: this.item_id,
            reorder_level: data.reorder_level || 0,
            min_quantity: data.min_quantity || 0,
            item_name: data.item_name || "",
            item_class_id: data.item_class_id || "",
            item_category_id: data.item_category_id || "",
            item_composition: data.item_composition || "",
            description: data.description || "",
            brand_name: data.brand_name || "",
            item_strength: data.item_strength || "",
          };

          this.form = form;
        }
      } catch (error) {
        console.error("Error fetching item:", error);
      }
    },
  },
  mounted() {
    this.get_all_class();
    this.get_all_cats();
    this.get_item_for_update();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

.text-end {
  text-align: right;
}
</style>
